var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-skeleton-loader',{attrs:{"types":_setup.types,"type":_setup.props.type,"dark":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }